module.exports = __webpack_public_path__ + "assets/4957ea352b395239dd6b77a5d82ef579.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet.mp3
 ** module id = 223
 ** module chunks = 0
 **/